import moment from 'moment';
import { GetAppearance } from 'src/utils/CommonFunctions';

export const useTimeZone = () => {
    const userTimezone = GetAppearance()?.timezone;

    // devnote: this is the date string format coming from the backend 2025-12-11T00:00:00.000Z
    const getDiff = (dateString: string) => {
        const dateFormatted = moment.utc(dateString).format('YYYY-MM-DD');

        const todayFormatted = moment.tz(userTimezone).format('YYYY-MM-DD');

        const date = moment(dateFormatted).startOf('day');

        const today = moment(todayFormatted).startOf('day');

        const diffDays = date.diff(today, 'days');

        return diffDays;
    };

    const isPickupDateToday = (date: Date | string | null | undefined) => {
        if (!date) return false;

        const currentDateString = moment.tz(userTimezone).format('YYYY-MM-DD');
        const pickupDateString = moment(date).format('YYYY-MM-DD');

        return currentDateString === pickupDateString;
    };

    const isDateInPast = (date: Date | string | null | undefined) => {
        if (!date) return false;

        const dateToCheck = moment(date).format('YYYY-MM-DD');
        const today = moment.tz(userTimezone).startOf('day').format('YYYY-MM-DD');

        return moment(dateToCheck).isBefore(moment(today), 'day');
    };

    return { getDiff, isPickupDateToday, isDateInPast };
};
